import { render } from "./BaseClinicPage.vue?vue&type=template&id=782513f5&scoped=true&ts=true"
import script from "./BaseClinicPage.vue?vue&type=script&lang=ts"
export * from "./BaseClinicPage.vue?vue&type=script&lang=ts"

import "./BaseClinicPage.vue?vue&type=style&index=0&id=782513f5&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-782513f5"]])

export default __exports__